import styles from './WeatherAttribution.module.css';

const WeatherAttribution = () => {
  return (
    <div className={styles.attributionContainer}>
      <span className={styles.attributionText}>Weather data © OpenWeather</span>
    </div>
  );
};

export default WeatherAttribution;
